export default __webpack_public_path__ + "static/media/right-arrow.1edcc5cb.svg";